
































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Report from '@/views/report/index.vue';
import { get_report } from '@/api/report';
import {
  translateComponentResource,
  vueSyncEvent,
  monthStringToIDate,
  stringToNumber,
} from '@/utils/index';
import { IDateRange } from '@/api/types';

const propOptions = 'options';

@Component({
  name: 'ReportStepOptions',
})
export default class extends Vue {
  private readonly months = Array.from({ length: 12 }, (_, k) => k + 1);
  private readonly viewOptionItems = Object.values(
    get_report.ViewOptionEnum
  ).filter(
    o =>
      (o as get_report.ViewOptionEnum) !==
      get_report.ViewOptionEnum.UNKNOWN_OPTION
  );
  private readonly columnFieldItems = Object.values(
    get_report.ColumnFieldEnum
  ).filter(
    f =>
      (f as get_report.ColumnFieldEnum) !==
      get_report.ColumnFieldEnum.UNKNOWN_FIELD
  );
  @Prop({ default: false }) vertical!: boolean;
  @Prop({ required: true }) year!: number;
  @Prop({ required: true }) options!: Partial<get_report.Request>;
  private fromMenu = false;
  private fromMonth: string | null = null;
  private fromMonthRules: ((v: string) => boolean | string)[] = [];
  private toMenu = false;
  private toMonth: string | null = null;
  private toMonthRules: ((v: string) => boolean | string)[] = [];
  private viewOptions: get_report.ViewOptionEnum[] = [];
  private columnFields: get_report.ColumnFieldEnum[] = [];

  get reportPreviousStepEvent() {
    return Report.reportPreviousStepEvent;
  }

  get canAggregateByMonth() {
    return this.columnFields.some(
      f =>
        (f as get_report.ColumnFieldEnum) ===
        get_report.ColumnFieldEnum.AGGREGATED_TOTAL
    );
  }

  mounted() {
    if (this.options.aggregatedMonthRange) {
      if (this.options.aggregatedMonthRange.start) {
        this.fromMonth = this.toAggregatedMonthStr(
          this.year,
          this.options.aggregatedMonthRange.start.month
        );
      }
      if (this.options.aggregatedMonthRange.end) {
        this.toMonth = this.toAggregatedMonthStr(
          this.year,
          this.options.aggregatedMonthRange.end.month
        );
      }
    }
    if (this.options.viewOptions && this.options.viewOptions.length > 0) {
      this.viewOptions = this.options.viewOptions;
    }
    if (this.options.columnFields && this.options.columnFields.length > 0) {
      this.columnFields = this.options.columnFields;
    }

    this.loadRules();
  }

  private loadRules() {
    this.fromMonthRules = [
      (v: string) =>
        !this.columnFields.some(
          f =>
            (f as get_report.ColumnFieldEnum) ===
            get_report.ColumnFieldEnum.AGGREGATED_TOTAL
        ) ||
        !!v ||
        (this.$t('{msg} is required', {
          msg: this.$t('From month'),
        }) as string),
    ];
    this.toMonthRules = [
      (v: string) =>
        !this.columnFields.some(
          f =>
            (f as get_report.ColumnFieldEnum) ===
            get_report.ColumnFieldEnum.AGGREGATED_TOTAL
        ) ||
        !!v ||
        (this.$t('{msg} is required', {
          msg: this.$t('To month'),
        }) as string),
    ];
  }

  private handlefromMonthInput(fromMonth: string | null) {
    this.fromMonth = fromMonth;
    const newOptions = this.generateOptions();
    this.$emit(vueSyncEvent(propOptions), newOptions);
    this.fromMenu = false;
  }

  private handletoMonthInput(toMonth: string | null) {
    this.toMonth = toMonth;
    const newOptions = this.generateOptions();
    this.$emit(vueSyncEvent(propOptions), newOptions);
    this.toMenu = false;
  }

  private handleViewOptionChange(b: boolean, item: get_report.ViewOptionEnum) {
    const newOptions = this.generateOptions();
    this.$emit(vueSyncEvent(propOptions), newOptions);
  }

  private handleColumnFieldEnumChange(
    b: boolean,
    item: get_report.ColumnFieldEnum
  ) {
    const newOptions = this.generateOptions();
    this.$emit(vueSyncEvent(propOptions), newOptions);
  }

  private generateOptions() {
    const newOptions = {} as Partial<get_report.Request>;

    newOptions.viewOptions = this.viewOptions;
    newOptions.columnFields = this.columnFields;
    if (this.canAggregateByMonth && (this.fromMonth || this.toMonth)) {
      newOptions.aggregatedMonthRange = {} as IDateRange;
      this.fromMonth &&
        (newOptions.aggregatedMonthRange.start = monthStringToIDate(
          this.fromMonth
        )!);
      this.toMonth &&
        (newOptions.aggregatedMonthRange.end = monthStringToIDate(
          this.toMonth
        )!);
    }

    return newOptions;
  }

  // TODO: this logic might need to be done in backend if it is supposed to be configuable
  private toAggregatedMonthStr(year: number, month: number) {
    return month < 4
      ? `${stringToNumber(year) + 1}-0${month}`
      : month < 10
      ? `${year}-0${month}`
      : `${year}-${month}`;
  }

  private fromAllowedDates(val: string | null) {
    return (
      !val ||
      ((!this.toMonth || val <= this.toMonth) &&
        val >= this.toAggregatedMonthStr(this.year, 4) &&
        val <= this.toAggregatedMonthStr(this.year, 3))
    );
  }

  private toAllowedDates(val: string | null) {
    return (
      !val ||
      ((!this.fromMonth || val >= this.fromMonth) &&
        val >= this.toAggregatedMonthStr(this.year, 4) &&
        val <= this.toAggregatedMonthStr(this.year, 3))
    );
  }

  private translateComponentResource(resource: string) {
    return translateComponentResource(
      this.$i18n,
      this.$options.name as string,
      resource
    );
  }
}
